import { toReadableDate } from '@/lib/dates';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ApartmentListingApplicationConfig,
  type ApartmentListingApplication,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const ApartmentListingApplicationItem: RelationFieldProps<ApartmentListingApplication> =
  {
    nested: getRelationFieldNames(ApartmentListingApplicationConfig),
    renderItem: (item) => {
      return {
        title: item.id,
        descriptionItems: (
          <div className='grid w-full'>
            <span>Intresseanmälde: {toReadableDate(item.createdAt)}</span>
          </div>
        ),
      };
    },
  };
